import React from "react";
import TableSearchBar from "../TableSearchBar";
import { DatePicker, Button, Select } from "components/ui";
import { GrPowerReset } from "react-icons/gr";
import { CiFilter } from "react-icons/ci";
import { firstDay, lastDay } from "utils/utils";
import { CUSTOMER_GROUP } from "constants/app.constant";
// import { useSelector } from "react-redux";
// import { ROLES } from "constants/roles.constant";

const FilterBar = ({
  search,
  FilterMenu,
  setSearch,
  setFilterValue,
  filterValue,
  onFilterClick,
  motionFilters,
  handleBtnClick,
  btnLabel,
  placeholder,
  customerCreditLimit,
  btnIcon,
  alwaysShowFilter,
  minDate
}) => {
  return (
    <div className="flex flex-wrap w-full items-center justify-between ">
      <div className="flex w-full gap-4 sm:w-8/12 md:w-8/12 lg:w-8/12 xl:w-8/12 pb-2">
        {FilterMenu?.isSearch && (
          <div className="flex w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 ">
            <TableSearchBar
              search={search}
              placeholder={placeholder}
              onChange={(query) => setSearch(query)}
              SearchBarInfo={FilterMenu?.isSearch?.toolTipText}
            />
          </div>
        )}       
        {FilterMenu?.isCalendarFilter && (
          <div className="flex w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 ">
            <DatePicker.DatePickerRange
              size="sm"
              dateViewCount={2}
              value={filterValue?.dateRange}
              placeholder={FilterMenu?.isCalendarFilter?.placeholder}
              inputFormat="DD MMMM YYYY"
              onChange={(dateArray) => {
                setFilterValue({
                  ...filterValue,
                  dateRange:
                    dateArray[0] && !dateArray[1]
                      ? [dateArray[0], dateArray[0]]
                      : dateArray,
                });
              }}
              minDate={minDate} // if there in props then set mindate 
            />
          </div>
        )}
      </div>
      <div className="flex w-full sm:w-3/12  md:w-1/12 lg:w-1/12 xl:w-1/12 justify-end pb-2">
        {!alwaysShowFilter &&
          FilterMenu?.isFilterButton &&
          !customerCreditLimit && (
            <Button
              size="sm"
              className={`mr-2 ${motionFilters && "text-[#68CFF0]"}`}
              onClick={onFilterClick}
              icon={<CiFilter color={motionFilters && "#68CFF0"} />}
            >
              Filter
            </Button>
          )}
        {FilterMenu?.isResetButton && (
          <Button
            size="sm"
            onClick={() => {
              let obj = {};
              Object.keys(filterValue).forEach((item) => {
                obj[item] = FilterMenu?.isResetButton?.filterKey[item];
              });
              obj.dateRange = minDate ? [minDate, lastDay] : [firstDay, lastDay];
              setFilterValue(obj);
              setSearch("");
            }}
            icon={<GrPowerReset />}
          >
            Reset
          </Button>
        )}
        {btnLabel && (
          <Button
            variant="solid"
            size="sm"
            className="ml-2"
            onClick={handleBtnClick}
            icon={btnIcon || ""}
          >
            {btnLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
export default FilterBar;
